import React from "react";
import ReactDOM from "react-dom";
import ThemeContext from "../../context/ThemeContext";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import { AnimatePresence, motion } from "framer-motion";
import { t } from "i18next";
const CasinoOverlay = ({ showCasinoUrl }) => {
  const theme = useContextSelector(ThemeContext, (ctx) => {
    return ctx.theme;
  });
  const setShowCasino = useContextSelector(AuthContext, (ctx) => {
    return ctx.setShowCasino;
  });
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });

  const getCurrentBalance = () => {
    // const user = useContextSelector(AuthContext, (ctx) => {
    //   return ctx.amounutRefresh();
    // });
  }

  const variants = {
    hidden: { y: 750 }, // start from bottom
    visible: { y: 0 }, // slide up into place
    exit: { y: 750 }, // slide up and out (top to bottom)
  };
  return ReactDOM.createPortal(
    <AnimatePresence mode="wait">
      <motion.div
        initial="hidden"
        animate="visible"
        exit="exit"
        variants={variants}
        transition={{ duration: 0.4, ease: "easeInOut" }}
        className="cdk-overlay-container"
      >
        <div className="cdk-overlay-backdrop dialog-backdrop cdk-overlay-backdrop-showing" />
        <div
          className="cdk-global-overlay-wrapper"
          dir="ltr"
          style={{
            "-webkit-box-pack": "center",
            "-webkit-justify-content": "center",
            "-ms-flex-pack": "center",
            "justify-content": "center",
            "-webkit-align-items": "center",
            "-webkit-box-align": "center",
            "-ms-flex-align": "center",
            "align-items": "center",
          }}
        >
          <div
            id="cdk-overlay-6"
            className="cdk-overlay-pane dialog-panel"
            style={{ position: "static" }}
          >
            <app-dialog _nghost-serverapp-c33280995>
              <div
                _ngcontent-serverapp-c33280995
                className="popup"
                id="dialog-6"
              >
                <div
                  _ngcontent-serverapp-c33280995
                  className="popup__header"
                ></div>
                <div _ngcontent-serverapp-c33280995 className="popup__content">
                  <ng-component
                    _nghost-serverapp-c3248189738
                    className="ng-star-inserted"
                  >
                    <div
                      _ngcontent-serverapp-c3248189738
                      className="launch-game-content ng-star-inserted active"
                    >
                      <div
                        _ngcontent-serverapp-c3248189738
                        className="launch-game-page"
                        style={{ display: "block" }}
                      >
                        <div
                          _ngcontent-serverapp-c3248189738
                          className="site-top"
                          style={{ display: "block" }}
                        >
                          <div
                            _ngcontent-serverapp-c3248189738
                            className="site-menu no-deposit"
                          >
                            <div
                              onClick={() => {
                                setShowCasino(false);
                              }}
                              _ngcontent-serverapp-c3248189738
                              className="btn"
                              style={{
                                "-webkit-transform": "translate(0px, 0px)",
                                "-ms-transform": "translate(0px, 0px)",
                                transform: "translate(0px, 0px)",
                                opacity: "1",
                              }}
                            >
                              <div
                                _ngcontent-serverapp-c3248189738
                                className="btn-cross"
                                onClick={() => {
                                  getCurrentBalance();
                                }}
                              />
                              <div
                                _ngcontent-serverapp-c3248189738
                                className="light-ring"
                                style={{
                                  "-webkit-transform": "translate(0px, 0px)",
                                  "-ms-transform": "translate(0px, 0px)",
                                  transform: "translate(0px, 0px)",
                                  opacity: "1",
                                }}
                              />
                            </div>
                            <div
                              _ngcontent-serverapp-c3248189738
                              className="info-wrap"
                              style={{
                                display: "block",
                                opacity: "1",
                                "-webkit-transform": "skew(-10.0002deg, 0deg)",
                                "-ms-transform": "skew(-10.0002deg, 0deg)",
                                transform: "skew(-10.0002deg, 0deg)",
                              }}
                            >
                              <div
                                _ngcontent-serverapp-c3248189738
                                className="info-block"
                              >
                                <div
                                  _ngcontent-serverapp-c3248189738
                                  className="info-title"
                                >
                                  {" "}
                                  {t("USER")}{" "}
                                </div>
                                <div
                                  _ngcontent-serverapp-c3248189738
                                  className="info-value"
                                >
                                  {user?.user?.username}
                                  {/* <span
                                  _ngcontent-serverapp-c3248189738
                                  className="info-value-sub ng-star-inserted"
                                >
                                  {" "}
                                  - V.223.178.98.34{" "}
                                </span> */}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c3248189738
                              className="f-logo-bg"
                              style={{
                                "-webkit-transform": "translate(0px, 0px)",
                                "-ms-transform": "translate(0px, 0px)",
                                transform: "translate(0px, 0px)",
                                opacity: "1",
                              }}
                            >
                              <div
                                _ngcontent-serverapp-c3248189738
                                className="f-logo logo-image"
                                style={{
                                  "background-image":'url("/assets/Other/logo-dark.png")',
                                }}
                              />
                              <div
                                _ngcontent-serverapp-c3248189738
                                className="light-ring"
                                style={{
                                  "-webkit-transform": "translate(0px, 0px)",
                                  "-ms-transform": "translate(0px, 0px)",
                                  transform: "translate(0px, 0px)",
                                  opacity: "1",
                                }}
                              />
                            </div>
                            <div
                              _ngcontent-serverapp-c3248189738
                              className="btn"
                              style={{
                                "-webkit-transform": "translate(0px, 0px)",
                                "-ms-transform": "translate(0px, 0px)",
                                transform: "translate(0px, 0px)",
                                opacity: "1",
                              }}
                            >
                              <div
                                _ngcontent-serverapp-c3248189738
                                className="btn-deposit"
                                style={{
                                  "mask-image":
                                    'url("/assets/Icon/icon-deposit.svg")',
                                }}
                              />
                            </div>
                            <div
                              _ngcontent-serverapp-c3248189738
                              className="menu-bg"
                              style={{
                                opacity: "1",
                                height: "100%",
                                width: "100%",
                              }}
                            >
                              <div
                                _ngcontent-serverapp-c3248189738
                                className="highlight"
                              />
                            </div>
                          </div>
                          <div
                            _ngcontent-serverapp-c3248189738
                            className="top-bg"
                            style={{
                              "-webkit-transform": "translate(0px, -100px)",
                              "-ms-transform": "translate(0px, -100px)",
                              transform: "translate(0px, -100px)",
                            }}
                          />
                        </div>
                        <div
                          _ngcontent-serverapp-c3248189738
                          className="site-bg"
                          style={{
                            display: "block",
                            "-webkit-transform": "translate(0px, 0px)",
                            "-ms-transform": "translate(0px, 0px)",
                            transform: "translate(0px, 0px)",
                          }}
                        />
                        <div
                          _ngcontent-serverapp-c3248189738
                          className="launch-game-wrap show"
                          style={{
                            "-webkit-transform": "translate(0px, 0px)",
                            "-ms-transform": "translate(0px, 0px)",
                            transform: "translate(0px, 0px)",
                          }}
                        >
                          <iframe
                            _ngcontent-serverapp-c3248189738
                            name="myiFrame"
                            marginHeight="0px"
                            marginWidth="0px"
                            height="603px"
                            width="375px"
                            allowFullScreen
                            className="launch-game-iframe"
                            style={{ border: "0px #ffffff none" }}
                            scrolling="yes"
                            src={showCasinoUrl}
                          />
                        </div>
                      </div>
                    </div>
                  </ng-component>
                </div>
              </div>
            </app-dialog>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>,
    document.getElementById("casino-overlay"),
  );
};

export default CasinoOverlay;
